import { CLEAR_FORGET_PASSWORD, FETCH_FORGET_PASSWORD, SET_FORGET_PASSWORD } from "../actions";

export const forgetPassword = (forgetPasswordData) => ({
    type: FETCH_FORGET_PASSWORD,
    payload: { forgetPasswordData },
});

export const setForgetPassword = (forgetPasswordData) => ({
    type: SET_FORGET_PASSWORD,
    payload: forgetPasswordData,
});

export const clearForgetPassword = () => ({
    type: CLEAR_FORGET_PASSWORD,
});
